import { SvgIcon, SvgIconProps } from '@mui/material';

const HexagonOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="HexagonOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.005 0.990234L21.5353 6.49259V17.4973L12.005 22.9996L2.47461 17.4973V6.49259L12.005 0.990234ZM12.005 3.29964L4.47461 7.64729V16.3426L12.005 20.6902L19.5353 16.3426V7.64729L12.005 3.29964Z"
      />
    </SvgIcon>
  );
};

export default HexagonOutlined;
